module.exports = __webpack_public_path__ + "static/media/playstore.253dcf48.png";